export default {"src":"/_next/static/media/SGD.9c2b1291.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};